import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch,useSelector } from "react-redux";
import styled from "styled-components";
import { Button } from "@vds/buttons";
import { Modal, ModalTitle,  ModalFooter } from "@vds/modals";
import { setNoThanksClicked } from '../../../../app/ducks/GlobalSlice'


const ShoppingCartNudgeModal = ({ opened, onOpenedChange,onContinue, url,loadShoppingCart=()=>{}, ...props }) => {
  const globalData = useSelector((state) => state.GlobalData);
  const dispatch = useDispatch();
  const sessionCartData =  globalData?.sessionCartData?.apiResponse?.prospectFlowData;
  const { t } = useTranslation(["4G-5G"]);
  const aemContent = t("4G-5G", { ns: "4G-5G", returnObjects: true });

    return (
      <Modal  surface="light"  hideCloseButton={false}   opened={opened}  onOpenedChange={onOpenedChange}  disableFocusLock= {true}  >
        <ModalTitle>{aemContent?.newJointOfferBundleFlow?.CartNudgeModal}</ModalTitle>
        <ModalFooter
            children={
              <ButtonGroup>
                <Button size="small" use="primary" width="100%"  onClick={()=>{onOpenedChange(false)}} >
                  {aemContent?.newJointOfferBundleFlow?.NudgeContinueBtn}
                </Button>
                <Button size="small" use="secondary" width="100%" onClick={()=>{loadShoppingCart()}} >
                  {aemContent?.newJointOfferBundleFlow?.NudgenoThnxBtn}
                </Button>
              </ButtonGroup>
            } 
        />
      </Modal>
    );
  };
  const ButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  @media (max-width: 545px) {
    flex-direction: column;
  }
`;
export default ShoppingCartNudgeModal;
